import React, { memo } from "react";
import ProductCard from "../components/ProductCard";
import Typography from "../../Typography";
import Box from "component/layoutComponents/Box";
import { useTheme } from "styled-components";
import DefaultUptimeTheme from "component/theme/defaultTheme";

type Props = {
  products:
    | {
        id: string;
        imgSrc: string;
        manufactory: string;
        productName: string;
      }[]
    | undefined;
  title: string;
};

const ProductRecommendations = ({ products, title }: Props) => {
  const theme = useTheme() as unknown as typeof DefaultUptimeTheme;
  return (
    <>
      <Box mt={`${theme.uptimeSpace[20]}px`}>
        <Typography variant="h6">{title}</Typography>
        <Box display="flex" mt={`${theme.uptimeSpace[6]}px`}>
          {products?.map((product: any, index: React.Key) => {
            const isLastProduct = index === products.length - 1;
            return (
              <Box
                mr={
                  isLastProduct
                    ? `${theme.uptimeSpace[0]}px`
                    : `${theme.uptimeSpace[6]}px`
                }
                key={product.id}
              >
                <ProductCard
                  onClick={() => {}}
                  checked={false}
                  imgSrc={product.imgSrc}
                  manufactory={product.manufactory}
                  productName={product.productName}
                />
              </Box>
            );
          })}
        </Box>
      </Box>
    </>
  );
};

export default memo(ProductRecommendations);
